import { incomeRange } from '@/method/data'

export const dataDefault = [{
    name: "Rooms Revenue % 客房收入占比",
    interval: 0,
    area: 0,
    hotel: 0,
    sort: 0,
}, {
    name: "F&B Revenue % 餐饮收入占比",
    interval: 0,
    area: 0,
    hotel: 0,
    sort: 1,
}, {
    name: "Other Revenue % 其他部门收入占比",
    interval: 0,
    area: 0,
    hotel: 0,
    sort: 2,
}, {
    name: "Rooms Dept Profit % 客房部门利润率",
    interval: 0,
    area: 0,
    hotel: 0,
    sort: 3,
}, {
    name: "F&B Dept Profit % 餐饮部门利润率",
    interval: 0,
    area: 0,
    hotel: 0,
    sort: 4,
}, {
    name: "F&B Cost % 餐饮成本率",
    interval: 0,
    area: 0,
    hotel: 0,
    sort: 5,
}, {
    name: "Coffee Shop Revenue % 咖啡厅收入占比",
    interval: 0,
    area: 0,
    hotel: 0,
    sort: 6,
}, {
    name: "Coffee Shop Cost % 咖啡厅成本率",
    interval: 0,
    area: 0,
    hotel: 0,
    sort: 7,
}, {
    name: "Chinese Restaurant Revenue % 中餐厅收入占比",
    interval: 0,
    area: 0,
    hotel: 0,
    sort: 8,
}, {
    name: "Chinese Restaurant Cost % 中餐厅成本率",
    interval: 0,
    area: 0,
    hotel: 0,
    sort: 9,
}, {
    name: "Banquet Revenue % 宴会收入占比",
    interval: 0,
    area: 0,
    hotel: 0,
    sort: 10,
}, {
    name: "Banquet Cost % 宴会成本率",
    interval: 0,
    area: 0,
    hotel: 0,
    sort: 11,
}, {
    name: "Labor Cost % 人力成本率",
    interval: 0,
    area: 0,
    hotel: 0,
    sort: 12,
}, {
    name: "Utility Cost % 能源成本率",
    interval: 0,
    area: 0,
    hotel: 0,
    sort: 13,
}, {
    name: "Other Expense and Cost % 其他费用及成本率",
    interval: 0,
    area: 0,
    hotel: 0,
    sort: 14,
}, {
    name: "Top 15 Vs. Total Purchase 前15位采购占总额比率",
    interval: 0,
    area: 0,
    hotel: 0,
    sort: 15,
}]


export const dataDefaultYear = [{
    name: "Rooms Revenue % 客房收入占比",
    industry: 0.539,
    area: 0,
    interval: 0,
    hotel: 0,
    sort: 0,
}, {
    name: "F&B Revenue % 餐饮收入占比",
    industry: 0.416,
    area: 0,
    interval: 0,
    hotel: 0,
    sort: 1,
}, {
    name: "Other Revenue % 其他部门收入占比",
    industry: 0.053,
    area: 0,
    interval: 0,
    hotel: 0,
    sort: 2,
}, {
    name: "Rooms Dept Profit % 客房部门利润率",
    industry: 0.729,
    area: 0,
    interval: 0,
    hotel: 0,
    sort: 3,
}, {
    name: "F&B Dept Profit % 餐饮部门利润率",
    industry: 0.273,
    area: 0,
    interval: 0,
    hotel: 0,
    sort: 4,
}, {
    name: "F&B Cost % 餐饮成本率",
    industry: 0.384,
    area: 0,
    interval: 0,
    hotel: 0,
    sort: 5,
}, {
    name: "Labor Cost % 人力成本率",
    industry: 0.352,
    area: 0,
    interval: 0,
    hotel: 0,
    sort: 6,
}, {
    name: "Utility Cost % 能源成本率",
    industry: 0.07,
    area: 0,
    interval: 0,
    hotel: 0,
    sort: 7,
}, {
    name: "Other Expense and Cost % 其他费用及成本率",
    industry: 0.113,
    area: 0,
    interval: 0,
    hotel: 0,
    sort: 8,
}, {
    name: "Top 15 Vs. Total Purchase 前15位采购占总额比率",
    industry: 0,
    area: 0,
    interval: 0,
    hotel: 0,
    sort: 9,
}]


export const intervalData = {
    ...incomeRange
};


export const dataSeasonal = [{
    name: "Coffee Shop Revenue % 咖啡厅收入占比",
    interval: 0,
    area: 0,
    hotel: 0,
    sort: 0,
}, {
    name: "Coffee Shop Cost % 咖啡厅成本率",
    interval: 0,
    area: 0,
    hotel: 0,
    sort: 1,
}, {
    name: "Chinese Restaurant Revenue % 中餐厅收入占比",
    interval: 0,
    area: 0,
    hotel: 0,
    sort: 2,
}, {
    name: "Chinese Restaurant Cost % 中餐厅成本率",
    interval: 0,
    area: 0,
    hotel: 0,
    sort: 3,
}, {
    name: "Banquet Revenue % 宴会收入占比",
    interval: 0,
    area: 0,
    hotel: 0,
    sort: 4,
}, {
    name: "Banquet Cost % 宴会成本率",
    interval: 0,
    area: 0,
    hotel: 0,
    sort: 5,
}]


// WEBPACK FOOTER //
// ./src/components/table/performanceAnalysis/data.js